import { footerFetcher } from 'redux/fetchers/footer';
import { menuFetcher } from 'redux/fetchers/menu';
import { all } from 'route-data/all';

export const navigationFetcher = all(menuFetcher, footerFetcher);
